import { Emitter } from '../emitter/emitter';
import { LocationService } from '../location/location.service';

export class ThumbnailGeneratorComponent extends Emitter {

	static getUID() {
		return `thumbnail-${new Date().getTime()}`;
	}

	get configurables() {
		return this.viewDescription ? this.viewDescription.productConfigurables : [];
	}

	get validConfigurations() {
		return this.viewDescription ? this.viewDescription.validConfigurations : [];
	}

	get clientInfo() {
		return this.viewDescription ? this.viewDescription.clientInfo : {};
	}

	get state() {
		return this.viewDescription ? this.viewDescription.productState : {};
	}

	get clientCode() {
		return this.viewDescription ? this.viewDescription.clientCode : null;
	}

	setViewDescription(viewDescription) {
		this.viewDescription = viewDescription;
	}

	constructor(node) {
		super();
		this.node = node;
		const canvas = this.canvas = document.createElement('canvas');
		canvas.style.cssText = 'width:435px;height:320px';
		canvas.id = ThumbnailGeneratorComponent.getUID();
		node.appendChild(canvas);
		let initialCode;
		const validConfigurations = productSheet.codes;
		const configurator = this.configurator = new KJ.CalligarisConfigurator(canvas.id, {
			assetsBaseUrl: '/docs/assets/conf.1.3', // productSheet.conf.ASSETS_PATH, // path to assets folder
			INVALID_CONFIGURATION: this.getInvalidConfiguration(), // what to do when requesting an invalid configuration
		});
		this.onReady = this.onReady.bind(this);
		this.onReadyCallback = () => {
			this.onReadyCallback = null;
			setTimeout(() => {
				if (this.viewDescription != null) {
					// console.log('>>>>>', this.viewDescription);
					this.emit('ready');
				}
			}, 100);
		};
		this.configurator.addObserver('3DViewReady', this.onReady);
		if (validConfigurations) {
			const param = decodeURI(LocationService.get('c'));
			if (param) {
				initialCode = validConfigurations.reduce((p, c) => {
					return p || (param.indexOf(c) !== -1 ? param : null);
				}, undefined);
			}
		}
		initialCode = initialCode || validConfigurations[0];
		this.index = 0;
		configurator.setActualProduct(initialCode, validConfigurations).then((viewDescription) => {
			// console.log('Configurator.setActualProduct', viewDescription);
			this.viewDescription = viewDescription;
		}, error => {
			console.log('ThumbnailGeneratorComponent.setActualProduct.error', error);
		});
		window.thumbnailGeneratorRender = this.render.bind(this);
	}

	onReady() {
		if (typeof this.onReadyCallback === 'function') {
			this.onReadyCallback();
		}
	}

	getInvalidConfiguration() {
		const dbType = productSheet.typeDB;
		this.dbType = dbType;
		let setting;
		switch (dbType) {
			case 'artcal':
				setting = 'error';
				break;
			case 'divcal':
				setting = 'return_first';
				break;
			case 'divd3':
				setting = 'return_first';
				break;
		}
		return setting;
	}

	destroy() {
		this.mediator = null;
		this.productViewMediator = null;
		this.controller = null;
		this.configurator = null;
		this.clientTranslator = null;
		window.thumbnailGeneratorRender = null;
	}

	render(clientCode) {
		return new Promise((resolve, reject) => {
			if (clientCode) {
				this.getSnapshots(clientCode).then(success => resolve(success), error => reject(error));
			} else {
				reject('invalid clientCode ' + clientCode);
			}
		});
	}

	getSnapshots(clientCode) {
		// console.log('ThumbnailGeneratorComponent.getSnapshots', clientCode);
		return new Promise((resolve, reject) => {
			this.onReadyCallback = () => {
				this.onReadyCallback = null;
				setTimeout(() => {
					// console.log('ThumbnailGeneratorComponent.getSnapshots.ready');
					this.getBase64Thumb(435, 320).then(base64 => {
						resolve(base64);
					}, error => {
						reject(error);
					});
				}, 1);
			};
			ThumbnailGeneratorComponent.setupCompositionFromClientCode(this, clientCode).then(success => {
				/*
				setTimeout(() => {
					this.getBase64Thumb(435, 320).then(base64 => {
						resolve(base64);
					}, error => {
						reject(error);
					});
				}, 500);
				*/
			});
		});
	}

	getBase64Thumb(width, height) {
		return new Promise((resolve, reject) => {
			try {
				const state = this.state;
				let screen = this.configurator.getProductConfigurationImage(state.selection, width, height, 'image/jpeg');
				// screen = screen.replace('data:image/jpeg;base64,', '');
				// console.log('ThumbnailGeneratorComponent.getBase64Thumb', screen);
				resolve(screen);
			} catch (error) {
				reject(error);
			}
		});
	}

	setConfigurationSettings() {
		const dbType = productSheet.typeDB;
		let setting;
		switch (dbType) {
			case 'artcal':
				setting = 'error';
				break;
			case 'divcal':
				setting = 'return_first';
				break;
			case 'divd3':
				setting = 'return_first';
				break;
		}
		return setting;
	}

	next_() {
		const configuration = this.getNextConfiguration_();
		this.getSnapshots(configuration).then(base64 => {
			// console.log('base64', base64);
			setTimeout(() => {
				this.next_();
			}, 1);
		}, error => {
			console.log('ThumbnailGeneratorComponent.next_.error', error);
		});
	}

	getNextConfiguration_() {
		const configuration = this.validConfigurations[this.index];
		this.index = (this.index + 1) % this.validConfigurations.length;
		// console.log(configuration.clientCode, configuration.configurables, this.configurator.changeConfigurables);
		return configuration;
	}

	update() {
		// !!! keep it
	}

	static setupCompositionFromClientCode(generator, clientCode) {
		return new Promise((resolve, reject) => {
			const configuration = generator.validConfigurations.find(x => x.clientCode === clientCode);
			if (configuration) {
				const configurables = configuration.configurables.map(x => {
					return {
						ID: x.ID,
						options: [x.selection],
						selection: x.selection,
					};
				});
				const viewDescription = generator.configurator.changeProductConfiguration(configurables);
				if (viewDescription != undefined) {
					generator.update(viewDescription);
				}
				resolve(generator.configurator);
			}
		});
	}

}
